export const SKIPTRACE_BATCH_MAX_LIMIT =  Number(process.env.REACT_APP_SKIPTRACE_LIMIT) ?? 25000;

export const PROPERTY_LISTING_PER_PAGE_LIMIT = 200;

export const DNC_CHECK_SKIP_PER_HIT = 0.1;

export const AGE_FILTER_SKIP_PER_HIT = 0.2;

export const PREV_OWNER_SKIP_PER_HIT = 10;

export const RELATIVE_DNC_CHECK_SKIP_PER_HIT = 0.5;
